import {
  APP_ROUTE_PATIENT_APPOINTMENTS,
  APP_ROUTE_PATIENT_CHARTS,
  APP_ROUTE_PATIENT_CHARTS_ARCHIVE,
  APP_ROUTE_PATIENT_HELP,
  APP_ROUTE_PATIENT_MEDICATIONS,
  APP_ROUTE_PATIENT_MESSAGES,
  APP_ROUTE_PATIENT_PROFILE,
  APP_ROUTE_PATIENT_RESULTS,
  APP_ROUTE_PATIENT_SETTINGS,
  APP_ROUTE_PATIENT_SUPPORT
} from '@data/patientRoutes'
import PatientCharts from '@pages/Patient/Charts'
import { lazy } from 'react'
import { APP_ROUTES_INDEX } from '../constants'
import type { RouteConfig } from './public.routes'

const PatientDashboard = lazy(() => import('@pages/Patient'))
const PatientAppointment = lazy(() => import('@pages/Patient/Appointment'))
// Eager Charts: PatientLayout keeps the "Chart" navbar while Outlet Suspense is empty; lazy
// Charts made tabs look like they flash away under the title.
const PatientResults = lazy(() => import('@pages/Patient/Results'))
const PatientMedications = lazy(() => import('@pages/Patient/Medications'))

/**
 * Patient app routes.
 * Only routes with existing patient pages are mapped for now.
 */
export const patientRoutes: RouteConfig[] = [
  { element: <PatientDashboard />, path: APP_ROUTES_INDEX },
  { element: <PatientAppointment />, path: APP_ROUTE_PATIENT_APPOINTMENTS },
  { element: <PatientCharts />, path: APP_ROUTE_PATIENT_CHARTS },
  { element: <PatientResults />, path: APP_ROUTE_PATIENT_RESULTS },
  { element: <PatientMedications />, path: APP_ROUTE_PATIENT_MEDICATIONS }
]

/**
 * Routes currently defined in patient constants but without a dedicated page yet.
 * Keep exported so other router layers can track planned patient surface area.
 */
export const patientPendingRoutePaths = [
  APP_ROUTE_PATIENT_MESSAGES,
  APP_ROUTE_PATIENT_CHARTS_ARCHIVE,
  APP_ROUTE_PATIENT_SUPPORT,
  APP_ROUTE_PATIENT_PROFILE,
  APP_ROUTE_PATIENT_SETTINGS,
  APP_ROUTE_PATIENT_HELP
] as const
